'use strict';

exports.__esModule = true;

var _leaflet = require('leaflet');

var _react = require('react');

exports.default = _react.PropTypes.instanceOf(_leaflet.Map);


//////////////////
// WEBPACK FOOTER
// ./~/react-leaflet/lib/types/map.js
// module id = 32
// module chunks = 0